<script>
import FooterWrapper from "@/components/FooterWrapper";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    FooterWrapper,
  },
  async created() {
    // Get the most recently created contract to check for shipped or transferred status to render proper text
    await this.getTeamContracts();
    if (
      this.teamContracts[0].shipped_or_transferred.toLowerCase() == "shipped"
    ) {
      this.message =
        "You are now fully onboarded. Because your machines are being shipped, please give us ample time to receive, inspect, and deploy your miners. ";
    } else if (
      this.teamContracts[0].shipped_or_transferred.toLowerCase() ==
      "transferred"
    ) {
      this.message =
        "You are now fully onboarded. Because your machines are being transferred and repointed to your team, please give us ample time to inspect and reconfigure them.";
    }
  },
  methods: {
    ...mapActions(["getTeamContracts"]),
    home() {
      this.$router.push({ path: "/" });
    },
  },
  computed: {
    ...mapState(["teamContracts"]),
  },
  data() {
    return {
      message: "Default Message",
    };
  },
};
</script>

<template>
  <FooterWrapper>
    <b-container class="mt-3">
      <b-row align-h="center">
        <b-col lg="9" xl="8">
          <div align="center">
            <img class="icon" src="@/assets/navier-logomark-simple.png" />
          </div>
          <b-card>
            <h1 align="center">Congratulations!</h1>
            <b-card-text class="welcome">
              {{ this.message }}
            </b-card-text>
            <b-card-text
              v-if="this.teamContracts[0].compatible"
              class="welcome"
            >
              You can check back in to Mine.App to see if your machine is
              hashing. If you have any questions in the meantime, please click
              on the below link to learn how to submit support tickets.
            </b-card-text>
            <b-card-text
              v-if="!this.teamContracts[0].compatible"
              class="welcome"
            >
              Your equipment will not be integrated with Mine.App, so your
              hashrate will not be managed through this platform. We will use
              your onboarding details to maintain records for billing purposes.
              If you have any questions in the meantime, please click on the
              below link to learn how to submit support tickets.
            </b-card-text>
            <b-card>
              <a
                target="_blank"
                href="https://www.loom.com/share/1fcd32d3e4ff40f4ae5b4ec7ca8ed484"
              >
                How to Submit a Support Ticket
              </a>
            </b-card>
          </b-card>
          <div class="spacer" />
          <div align="center">
            <b-button size="lg" variant="primary" @click="home">
              Mine.App Home
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </FooterWrapper>
</template>

<style scoped>
.welcome {
  font-size: 20px;
}
.spacer {
  height: 10px;
}
.icon {
  height: 240px;
  width: 240px;
}
.button {
  align-items: center;
}
</style>
